import script from "./letterReport.vue?vue&type=script&setup=true&lang=js"
export * from "./letterReport.vue?vue&type=script&setup=true&lang=js"

import "./letterReport.vue?vue&type=style&index=0&id=21f3c2e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21f3c2e4"]])

export default __exports__